import { NavItem, HeroSlide, BusinessService, NoticeItem, QuickMenuItem, InfoCard } from '../types';

export const navigationData: NavItem[] = [
  {
    id: 'about',
    label: '조직 현황',
    href: '/company/about',
    submenu: [
      { id: 'about-1', label: '관리원 소개', href: '/company/about' },
      { id: 'about-2', label: '이사장 인사말', href: '/company/message' },
      { id: 'about-3', label: '비전/경영전략', href: '/company/vision' },
      { id: 'about-4', label: '연혁', href: '/company/history' },
      { id: 'about-5', label: '조직도', href: '/company/org' },
      { id: 'about-6', label: 'CI', href: '/company/ci' },
      { id: 'about-7', label: '사회공헌', href: '/company/contribution' },
      { id: 'about-8', label: '찾아오시는 길', href: '/company/map' },
    ],
  },
  {
    id: 'business',
    label: '주요사업',
    href: '/business/b1',
    submenu: [
      { id: 'business-1', label: '승강기 검사', href: '/business/b1' },
      { id: 'business-2', label: '승강기 안전문화 확산', href: '/business/b2' },
      { id: 'business-3', label: '승강기 기술협력/교류', href: '/business/b3' },
      { id: 'business-4', label: '승강기 발전 연구개발', href: '/business/b4' },
    ],
  },
  {
    id: 'inspection',
    label: '승강기 검사안내',
    href: '/check/c1',
    submenu: [
      { id: 'inspection-1', label: '검사안내', href: '/check/c1' },
      {
        id: 'inspection-2',
        label: '검사신청방법',
        href: 'https://minwon.koelsa.or.kr/SubPage.do?pageid=sub00017',
        isExternal: true,
        icon: '/images/ico_window_w.gif'
      },
      { id: 'inspection-3', label: '검사수수료', href: '/check/c3' },
      {
        id: 'inspection-4',
        label: '검사신청',
        href: 'https://minwon.koelsa.or.kr',
        isExternal: true,
        icon: '/images/ico_window_w.gif'
      },
      { id: 'inspection-5', label: '민원상담 처리절차', href: '/cs/cs4' },
    ],
  },
  {
    id: 'info',
    label: '승강기 생활/정보',
    href: '/law',
    submenu: [
      { id: 'info-1', label: '승강기관련 법령', href: '/law' },
      {
        id: 'info-2',
        label: '승강기 설치통계',
        href: 'https://home.koelsa.or.kr/portal/contents.do?mId=0201020100',
        isExternal: true,
        icon: '/images/ico_window_w.gif'
      },
      {
        id: 'info-3',
        label: '승강기 사고통계',
        href: 'https://home.koelsa.or.kr/portal/contents.do?mId=0203020000',
        isExternal: true,
        icon: '/images/ico_window_w.gif'
      },
      { id: 'info-4', label: '승강기 안전관리', href: '/info/b4' },
      { id: 'info-5', label: '승강기 기술/부품', href: '/info/b5' },
    ],
  },
  // {
  //   id: 'customer',
  //   label: '고객서비스',
  //   href: '/cs/cs1',
  //   submenu: [
  //     { id: 'customer-1', label: '지주회는 집단', href: '/cs/cs1' },
  //     { id: 'customer-2', label: '검증성적', href: '/cs/cs4' },
  //     { id: 'customer-3', label: '민원상담 처리절차', href: '/cs/cs1' },
  //     { id: 'customer-4', label: '질의답변(Q&A)', href: '/qna' },
  //     { id: 'customer-5', label: '고객성만 고객센탄', href: '/communication' },
  //   ],
  // },
  {
    id: 'news',
    label: '소식/홍보',
    href: '/notice',
    submenu: [
      { id: 'news-1', label: '공지사항', href: '/notice' },
      { id: 'news-2', label: '언론보도', href: '/press' },
      { id: 'news-3', label: '공고', href: '/announcement' },
      { id: 'news-4', label: '홍보물', href: '/promotion' },
      { id: 'news-5', label: '관리원 소식', href: '/companynotice' },
      { id: 'news-7', label: '질의답변(Q&A)', href: '/qna' },
    ],
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: 'slide-1',
    title: '기술로 지키는 승강기 안전,<br>국민과 함께합니다!',
    subtitle: '한국승강기안전기술관리원',
    image: '/images/hero-banner-02.jpg',
  },
  {
    id: 'slide-2',
    title: '기술로 지키는 승강기 안전,<br>국민과 함께합니다!',
    subtitle: '한국승강기안전기술관리원',
    image: '/images/hero-banner-01.jpg',
  },
];

export const businessServices: BusinessService[] = [
  { id: 'service-1', title: '승강기<br>정기검사', icon: '/images/business-icon-01.gif', href: '/business/b1' },
  { id: 'service-2', title: '승강기<br>안전관리책임', icon: '/images/business-icon-02.gif', href: '/business/b2' },
  { id: 'service-3', title: '승강기<br>발전 연구개발', icon: '/images/business-icon-03.gif', href: '/business/b4' },
  { id: 'service-4', title: '승강기<br>기술관리', icon: '/images/business-icon-04.gif', href: '/business/b3' },
  { id: 'service-5', title: '승강기<br>안전 통계정보', icon: '/images/business-icon-05.gif', href: '/info/b4' },
  { id: 'service-6', title: '승강기<br>조회', icon: '/images/business-icon-06.gif', href: '/info/b5' },
];

export const noticeItems: NoticeItem[] = [
  { id: 'notice-1', text: '공지사항 입니다.', date: '03.28', href: '/notice' },
];

export const quickMenuItems: QuickMenuItem[] = [
  {
    id: 'quick-1',
    title: '승강기 검사안내 신청',
    description: '승강기 검사안내를 인터넷과<br>승강기를 이용하실 수 있습니다',
    href: '/check/c1',
    backgroundImage: '/images/quick-bg-04.gif',
  },
  {
    id: 'quick-2',
    title: '민원상담',
    description: '각종 민원, 제안, 또는 등 고객 여러분의<br>의견을 듣고 관리 문의하실 수 있습니다.',
    href: '/cs/cs4',
    backgroundImage: '/images/quick-bg-01.gif',
  },
];

export const infoCards: InfoCard[] = [
  {
    id: 'info-1',
    label: 'INFORMATION',
    title: '승강기 생활/정보',
    description: '(재)한국승강기안전기술관리원의<br>승강기 생활과 정보입니다.',
    icon: '/images/info-card-01.png',
    type: 'cyan',
    href: '/law',
  },
  {
    id: 'info-2',
    label: 'CONTRIBUTION',
    title: '사회공헌',
    description: '소외되고 어려운 이웃을 향한<br>따뜻한 관심과 사랑나눔 실천',
    icon: '/images/info-card-02.png',
    type: 'navy',
    href: '/company/contribution',
  },
  {
    id: 'info-3',
    label: 'PROMOTION',
    title: '홍보물',
    description: '(재)한국승강기안전기술관리원의<br>홍보물을 보실 수 있습니다.',
    icon: '/images/info-card-03.png',
    type: 'yellow',
    href: '/promotion',
  },
];
